import {StorageKey} from "../../../../enums/StorageKey";
import {t} from "@lingui/macro";

export default {
    storageKey: StorageKey.report_double_entry_detail,
    getReportLabel: () => t`Double Entry Detail`,
    getColumns: () => [],
};
